module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "dialogImgAddTag",
    attrs: {
      "title": "选择图片对应标签",
      "size": "tiny",
      "visible": _vm.dialogImageAddTagVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogImageAddTagVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "radioGroup",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, _vm._l((_vm.tagList), function(tag, index) {
    return _c('el-col', {
      key: index,
      staticStyle: {
        "height": "30px",
        "line-height": "30px",
        "text-align": "center",
        "margin": "5px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-radio', {
      staticClass: "is-bordered",
      class: tag.isChecked == true ? 'is-checked' : '',
      attrs: {
        "label": tag.tagType,
        "border": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.tagTypeChange(tag)
        }
      },
      model: {
        value: (_vm.tagTypeSelected),
        callback: function($$v) {
          _vm.tagTypeSelected = $$v
        },
        expression: "tagTypeSelected"
      }
    }, [_vm._v(_vm._s(tag.tagName))])], 1)
  })), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "margin-right": "2px"
    },
    on: {
      "click": function($event) {
        _vm.dialogImageAddTagVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.imageAddTag
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62d02b18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/dialogImageAddTag.vue
// module id = 565
// module chunks = 64